export default "__VITE_PUBLIC_ASSET__c4d3d5be__"